import React from "react"

import { contextPlaceholderFunction } from "@/lib/context/placeholderFunction"
import type { Loading } from "@/lib/loading"
import { unloadedProcesses } from "@/lib/loading/unloadedProcesses"

export const LoadingContext = React.createContext<Loading.ContextData>({
  processes: unloadedProcesses,
  ready: false,
  update: contextPlaceholderFunction,
})
